/**
 * One folding group of the review inboxes – a topic of documents, a campaign
 * or a topic of email drafts. The page owns the rows and the fold state.
 */
import type { ReactNode } from "react";

import { humanizeDuration } from "../../lib/aiTeam";
import { Pill } from "../Pill";

export function ReviewGroup({
  name,
  count,
  urgent,
  oldestWaitingSeconds,
  folded,
  onToggle,
  action,
  children,
}: {
  name: string;
  count: number;
  /** Pending P1 rows. */
  urgent: number;
  /** Null when nothing in the group waits on the owner. */
  oldestWaitingSeconds: number | null;
  folded: boolean;
  onToggle: () => void;
  /** A link beside the toggle, e.g. "campaign →". */
  action?: ReactNode;
  /** The rows (`<li>`), rendered while unfolded. */
  children: ReactNode;
}) {
  return (
    <section className="panel panel--flush">
      <div className="flex items-center">
        <button className="queue-group-toggle flex-1 min-w-0" type="button" aria-expanded={!folded} onClick={onToggle}>
          <span aria-hidden="true">{folded ? "▸" : "▾"}</span>
          <span className="font-semibold truncate min-w-0">{name}</span>
          <span className="font-mono text-xs text-ink-low">{count}</span>
          {urgent ? <Pill value={`${urgent} urgent`} tone="alert" /> : null}
          {oldestWaitingSeconds !== null ? (
            <span className="text-xs text-ink-low ml-auto shrink-0">oldest waiting {humanizeDuration(oldestWaitingSeconds)}</span>
          ) : null}
        </button>
        {action}
      </div>
      {!folded ? <ul className="divide-y divide-rule border-t border-rule">{children}</ul> : null}
    </section>
  );
}
